import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";

import axios from "axios";
import { Form } from "react-bootstrap";
import { ArrowRight, Eye, EyeSlash } from "iconsax-react";

import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";

import {
  resetPasswordApi,
  resetPasswordCheckCodeApi,
  resetPasswordRequestApi,
} from "../../utility/api/apiList";

import { ROUTE_AUTHENTICATION } from "../../routes";

import logo from "../../image/authentication/authentication-logo.png";

import TimerComponent from "../../components/public/countDown";
import OTPComponent from "../../components/public/OTP";
import ButtonComponent from "../../components/public/button";

import {
  StyledForm,
  StyledAuthenticationSection,
  StyledContainer,
  StyledAuthenticationLogoWrapper,
  StyledAuthenticationLogo,
  StyledFormGroup,
  StyledBackLink,
} from "../../components/public/login/loginStyled";

import {
  AzStepConnector,
  AzStepIcon,
  StyledFloatingLabel,
} from "./styledForgetPassPage";

export default function HorizontalLabelPositionBelowStepper(props) {
  const loginDetail = useSelector((state) => state.loginDetail);
  const dispatch = useDispatch();

  const [activeStep, setActiveStep] = React.useState(0);
  //phone
  const [phoneNumber, setPhoneNumber] = useState("");
  const [phoneError, setPhoneError] = useState("");
  //got code
  const [OTP, setOTP] = useState(new Array(5).fill(""));
  const [OTPError, setOTPError] = useState("");

  //register input value
  const [firstNameValue, setFirstNameValue] = useState("");
  const [firstNameError, setFirstNameError] = useState("");

  const [familyNameValue, setFamilyNameValue] = useState("");
  const [familyNameError, setFamilyNameError] = useState("");

  // Error content
  const [passwordValue, setPasswordValue] = useState("");
  const [passwordError, setPasswordError] = useState("");

  const [confirmPasswordValue, setConfirmPasswordValue] = useState("");
  const [confirmPasswordError, setConfirmPasswordError] = useState("");

  //input type
  const [newPassIsShow, setNewPassIsShow] = useState(false);
  const [confirmNewPassIsShow, setConfirmNewPassIsShow] = useState(false);

  const inputContainer = useRef(null);
  useEffect(() => {
    document.title = "فراموشی رمز عبور";
    setPhoneNumber(loginDetail.username);
    if (inputContainer.current) inputContainer.current.focus();
  }, []);

  const handlePhone = (e) => {
    setPhoneNumber(e.target.value);
  };
  const handleResetPassGetCode = (e) => {
    e.preventDefault();
    const phone = {
      username: phoneNumber,
    };
    axios
      .post(resetPasswordRequestApi, phone)
      .then((response) => {
        setActiveStep(1);
      })
      .catch((error) => {
        if (error.response.data.username) {
          setPhoneError(error.response?.data?.username);
        }
        if (error.response?.data?.non_field_errors) {
          setPhoneError(error?.response?.data.non_field_errors);
        }
        if (error.response.data.results) {
          setPhoneError(error?.response?.data.results);
        }
      });
    const FinishedTime = setTimeout(() => {
      // this.setState(() => ({ ErrorGetCode: false }));
    }, 2500);
  };

  const handleSubmitVerification = (e) => {
    e.preventDefault();
    const userVerification = {
      code: OTP.join(""),
      username: phoneNumber,
    };
    axios
      .post(resetPasswordCheckCodeApi, userVerification)
      .then((response) => {
        setActiveStep(2);
      })
      .catch((error) => {
        setOTPError(error?.response?.data.code[0]);
      });
  };

  const handleGetCodeAgain = () => {
    const phone = {
      username: phoneNumber,
    };
    axios.post(resetPasswordRequestApi, phone).then(() => {
      setOTPError("");
    });
  };

  const handleBackGetCode = (e) => {
    e.preventDefault();
    setActiveStep(1);
    setPhoneNumber("");
  };

  const handlePassword = (e) => {
    setPasswordValue(e.target.value);
  };
  const handleConfirmPassword = (e) => {
    setConfirmPasswordValue(e.target.value);
  };

  const handleResetPassword = (e) => {
    e.preventDefault();

    console.log("reset pass");
    const userInf = {
      username: phoneNumber,
      password: passwordValue,
      password_confirm: confirmPasswordValue,
      code: OTP.join(""),
    };

    axios
      .post(resetPasswordApi, userInf)
      .then((response) => {
        let prevPathPassed = "";
        if (props.location.state) {
          prevPathPassed = props.location.state.prevPath;
        } else {
          prevPathPassed = "/";
        }
        dispatch({
          type: "START_LOGIN",
          username: phoneNumber,
          password: passwordValue,
          prevPath: prevPathPassed,
        });
      })
      .catch((error) => {
        if (error.response.data.code) {
          alert(error?.response?.data.code);
        }
        error.response.data.password
          ? setPasswordError(error?.response?.data.password)
          : setPasswordError("");
        error.response.data.password_confirm
          ? setConfirmPasswordError(error?.response?.data.password_confirm)
          : setConfirmPasswordError("");
      });
  };
  const handleChangeTypeOfInputNewPassword = () => {
    setNewPassIsShow(!newPassIsShow);
  };
  const handleChangeTypeOfInputConfirmNewPassword = () => {
    setConfirmNewPassIsShow(!confirmNewPassIsShow);
  };

  function getSteps() {
    return ["ثبت شماره", "احراز هویت", "تغییر رمز"];
  }
  const steps = getSteps();

  const forgetPassStepsFunctions = [
    handleResetPassGetCode,
    handleSubmitVerification,
    handleResetPassword,
  ];

  function getStepContent(stepIndex) {
    switch (stepIndex) {
      case 0:
        return (
          <>
            <div>
              <Form.Label htmlFor="phone-number">
                لطفا شماره همراه خود را وارد کنید.
              </Form.Label>
              <Form.Control
                type="number"
                pattern="\d*"
                className="mt-2"
                id="phone-number"
                placeholder="09123456789"
                ref={inputContainer}
                onChange={handlePhone}
                value={phoneNumber}
                maxLength="11"
                autoFocus
              />
              <Form.Text className={phoneError ? "text-danger" : "text-muted"}>
                {phoneError ? phoneError : "لطفا شماره را با کد 0 وارد کنید."}
              </Form.Text>
            </div>
            <ButtonComponent
              type="submit"
              className="px-5 mt-5 w-100"
              disabled={!phoneNumber}
            >
              تایید
            </ButtonComponent>
          </>
        );
      case 1:
        return (
          <>
            <Form.Group className="text-center">
              <Form.Label htmlFor="password" className="d-block text-center">
                کد ارسال شده به شماره همراه
                <span className="text-primary"> {loginDetail.username}</span> را وارد
                کنید.
              </Form.Label>
              <OTPComponent
                setOTP={setOTP}
                OTP={OTP}
                errorMessage={OTPError}
              ></OTPComponent>
            </Form.Group>
            <div className="text-center mt-4">
              <TimerComponent handleGetCodeAgain={handleGetCodeAgain} />
              <ButtonComponent
                type="submit"
                className="px-5 mt-3 w-100"
                disabled={OTP.includes("")}
              >
                ارسال
              </ButtonComponent>
            </div>
          </>
        );
      case 2:
        return (
          <>
            <StyledFloatingLabel
              controlId="new-pass"
              label="رمز عبور جدید"
              className="mb-4"
            >
              <Form.Control
                type={newPassIsShow ? "text" : "password"}
                name="new-pass"
                ref={inputContainer}
                dir="ltr"
                onChange={handlePassword}
                placeholder="رمز عبور جدید"
                value={passwordValue}
                autoFocus
              />
              <span
                onClick={handleChangeTypeOfInputNewPassword}
                className="input-group-eye"
              >
                {newPassIsShow ? (
                  <EyeSlash size="24" color="var(--blue-color-dark)" />
                ) : (
                  <Eye size="24" color="var(--blue-color-dark)" />
                )}
              </span>
              {passwordError && (
                <Form.Text className="position-absolute text-danger">
                  {passwordError}
                </Form.Text>
              )}
            </StyledFloatingLabel>

            <StyledFloatingLabel
              controlId="confirm-new-pass"
              label="تکرار رمز عبور جدید"
            >
              <Form.Control
                type={confirmNewPassIsShow ? "text" : "password"}
                name="confirm-new-pass"
                dir="ltr"
                onChange={handleConfirmPassword}
                placeholder="تکرار رمز عبور جدید"
                value={confirmPasswordValue}
              />
              {confirmPasswordError && (
                <Form.Text className="position-absolute text-danger">
                  {confirmPasswordError}
                </Form.Text>
              )}
            </StyledFloatingLabel>
            <ButtonComponent
              type="submit"
              className="px-5 mt-5 w-100"
              disabled={!passwordValue || !confirmPasswordValue}
            >
              تغییر رمز
            </ButtonComponent>
          </>
        );
      default:
        return;
    }
  }

  return (
    <StyledAuthenticationSection>
      <StyledContainer>
        <StyledForm
          noValidate
          className="px-sm-5"
          onSubmit={forgetPassStepsFunctions[activeStep]}
        >
          <StyledAuthenticationLogoWrapper className="mx-auto mb-0">
            <StyledAuthenticationLogo src={logo} alt="azeto-logo" />
            <h1 className="h6 text-center">فراموشی رمز عبور</h1>
          </StyledAuthenticationLogoWrapper>
          <StyledFormGroup>
            <Stepper
              activeStep={activeStep}
              alternativeLabel
              connector={<AzStepConnector />}
              className="px-0"
            >
              {steps.map((label) => (
                <Step key={label}>
                  <StepLabel StepIconComponent={AzStepIcon}>{label}</StepLabel>
                </Step>
              ))}
            </Stepper>
            <div className="my-4">{getStepContent(activeStep)}</div>
          </StyledFormGroup>
        </StyledForm>
        <StyledBackLink
          to={{
            pathname: ROUTE_AUTHENTICATION,
            state: { prevPath: "loginByPassComponent" },
          }}
        >
          <ArrowRight size="32" color="var(--dark-color)" variant="Outline" />
        </StyledBackLink>
      </StyledContainer>
    </StyledAuthenticationSection>
  );
}
